var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"auth-card-header"},[_c('img',{staticClass:"auth-logo",attrs:{"src":require("@/assets/images/customily-logo.png"),"alt":"Customily"}}),_vm._v(" "),_c('h5',{staticClass:"auth-title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }